let browser = null;

function _getBrowser_() {
    if (navigator.userAgent.indexOf('MSIE') > -1) return 'IE';
    if (navigator.userAgent.indexOf('Firefox') > -1) return 'Firefox';
    const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    let isSafari = navigator.userAgent.indexOf('Safari') > -1;
    const isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
    if (isChrome && isSafari) isSafari = false;
    if (isChrome && isOpera) return 'op';
    if (isChrome) return 'Chrome';
    if (isSafari) return 'Safari';
    return 'unknown';
}

export const GetBrowser = () => {
    if (browser !== null) return browser;
    browser = _getBrowser_();
    return browser;
};

export default GetBrowser;
